import useSWR from 'hooks/useSWR';
import { Stage } from 'types';
import { List } from 'types/api';
import { useSWRResource } from 'util/resource/useSWRResource';
import { companiesAPIUrls } from '../companies/companiesApi';

export const fundingStagesKey = companiesAPIUrls.fundingStageLabels.listAll();

export const useFundingStages = () => {
  const swrResult = useSWR<List<Stage>>(fundingStagesKey);
  return useSWRResource(swrResult);
};
